import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        "rounded-xl border border-border bg-surface-card shadow",
        className,
      )}
      {...rest}
    />
  ),
);
Card.displayName = "Card";

export const CardHeader = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...rest }, ref) => (
  <div ref={ref} className={cn("px-8 pt-8 pb-4 space-y-1", className)} {...rest} />
));
CardHeader.displayName = "CardHeader";

export const CardTitle = forwardRef<
  HTMLHeadingElement,
  HTMLAttributes<HTMLHeadingElement>
>(({ className, ...rest }, ref) => (
  <h2
    ref={ref}
    className={cn(
      "text-display-sm font-semibold text-ink tracking-[-0.015em]",
      className,
    )}
    {...rest}
  />
));
CardTitle.displayName = "CardTitle";

export const CardSubtitle = forwardRef<
  HTMLParagraphElement,
  HTMLAttributes<HTMLParagraphElement>
>(({ className, ...rest }, ref) => (
  <p
    ref={ref}
    className={cn("text-body text-ink-muted", className)}
    {...rest}
  />
));
CardSubtitle.displayName = "CardSubtitle";

export const CardBody = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...rest }, ref) => (
  <div ref={ref} className={cn("px-8 py-6", className)} {...rest} />
));
CardBody.displayName = "CardBody";

export const CardFooter = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...rest }, ref) => (
  <div
    ref={ref}
    className={cn(
      "border-t border-border-subtle bg-surface-subtle/40 px-8 py-4 rounded-b-xl",
      className,
    )}
    {...rest}
  />
));
CardFooter.displayName = "CardFooter";
